import React, {useEffect, useState} from "react";
import axios from 'axios';
import {getUser, PHP_API} from "../../../utils/Common";
import {Button, Dropdown, Form, Grid, Table} from "semantic-ui-react";

const RpteFertilizacion = (props) => {
    const [user, _] = useState({...getUser()});
    const [reportes, setReportes] = useState([]);
    const [inventario, setInventario] = useState([]);

    useEffect(() => {
        console.log(user);
        getReportes();
        getInvCampo();
    }, [])

    function getReportes() {
        axios.get(PHP_API + 'get_rptes_fertilizacion', {params: {user_id: user.id}})
            .then(r => {
                console.log(r.data);
                setReportes([...r.data.reportes]);
            });
    }

    function getInvCampo() {
        axios.get(PHP_API + 'get_invcampo_drop')
            .then(r => {
                console.log(r.data);
                setInventario([...r.data.inventario]);
            });
    }

    return (
        <React.Fragment>
            <div className="w-full p-3 right-0">
                <div className="bg-white border rounded shadow-xl">
                    <div className="border-b rounded-t p-3 bg-orange-900">
                        <h5 className="font-bold uppercase text-white">Reporte de Fertilización</h5>
                        {user && <p className="text-white text-sm">Bienvenido, {user.nombre}</p>}
                    </div>
                    <div className="p-5 rounded-b">
                        {/* ---- CONTENIDO --- */}
                        <Grid style={{marginTop: '10px'}} columns={2} divided>
                            <Grid.Column>
                                <h3>Reportes Registrados</h3>
                                <Table celled>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Fecha Fertilización</Table.HeaderCell>
                                            <Table.HeaderCell>Fórmula</Table.HeaderCell>
                                            <Table.HeaderCell>Cantidad</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {reportes.map((r, i) => {
                                            return (
                                                <Table.Row>
                                                    <Table.Cell>{r.created_at}</Table.Cell>
                                                    <Table.Cell>{r.formula}</Table.Cell>
                                                    <Table.Cell>{r.cantidad}</Table.Cell>
                                                </Table.Row>
                                            );
                                        })}
                                    </Table.Body>
                                </Table>
                            </Grid.Column>
                            <Grid.Column>
                                <h3>Registro del Reporte</h3>
                                <Form>
                                    <Form.Field>
                                        <label>Inventario:</label>
                                        <Dropdown fluid search name="planid" selection options={inventario} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Fórmula Empleada:</label>
                                        <input type="text"/>
                                    </Form.Field>
                                    <Form.Field>
                                        <label htmlFor="">Cantiadad</label>
                                        <input type="number"/>
                                    </Form.Field>
                                </Form>
                                <Button style={{marginTop: '10px'}}>Registrar</Button>
                            </Grid.Column>
                        </Grid>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default RpteFertilizacion;
